import * as React from "react";
import { cn } from "@/lib/utils";

type Variant = "default" | "success" | "warning" | "destructive" | "muted";

const styles: Record<Variant, string> = {
  default: "bg-primary text-primary-foreground",
  success: "bg-[#eaf8f0] text-[#218257] border border-[#bfe8d3]",
  warning: "bg-[#fff5e3] text-[#ad6b1a] border border-[#f3dcb0]",
  destructive: "bg-[#fff0ef] text-[#c33d32] border border-[#f2c8c5]",
  muted: "bg-[#eef1f5] text-[#738096]",
};

export function Badge({
  variant = "default",
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: Variant }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-[4px] px-1.5 py-0.5 text-[10px] font-semibold",
        styles[variant],
        className
      )}
      {...props}
    />
  );
}
